import {
  Container,
  FormSignUp,
  LoginBox,
  Logo,
  PageTitle,
  RadioContainer,
} from "./styles";
import capivara from "../../../../assets/images/capivara.png";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Radio } from "@mui/material";
//import { toast } from "react-toastify";
//import { LoginService } from "../../services";
import { TUserType } from "../../../users/models";
import permissionsStore from "../../../../store/permissions";
import { LoadingContainer } from "../main/styles";
import { useAuthContext } from "../../../../contexts";
import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Form from "@/components/Form";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

export const SignUpSocial: React.FC = () => {
  const { role, storageUser } = permissionsStore();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const { executeRecaptcha } = useGoogleReCaptcha();
  /*
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const email = urlParams.get("email");
  const name = urlParams.get("name");*/
  const [userType, setUserType] = useState<TUserType>("PERSON");
  const [loading, setLoading] = useState<boolean>(true);

  const schemaSignUpForm = z.object({
    name: z.string().nonempty("O Nome é obrigatório"),
    phone: z
      .string()
      .nonempty("O Telefone é obrigatório")
      .min(11, { message: "Informe o número completo" }),
    cpfCnpj: z.string().min(14, { message: "Preencha corretamente" }),
  });

  type signUpFormProps = z.infer<typeof schemaSignUpForm>;

  const signUpForm = useForm<signUpFormProps>({
    resolver: zodResolver(schemaSignUpForm),
  });

  useEffect(() => {
    if (role && storageUser && user) {
      navigate("/home");
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handleUserType = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserType((event.target as HTMLInputElement).value as TUserType);
  };
  const handleSubmit = async (data: signUpFormProps) => {
    setLoading(true);
    if (!executeRecaptcha) {
      console.error("Erro ao gerar token captcha;", data);
      return false;
    }
    //const token = await executeRecaptcha("ambassador");
    //Criar um endpoint para o cadastro do usuário via social login
    /*    LoginService.signUp({
      fullName: data.name,
      phone: data.phone,
      doc: data.cpfCnpj,
      type: userType,
      token,
      ambassador,
    }).then((response) => {
      if (response.success) {
        toast.success("Conta criada com sucesso!");
        navigate("/credits");
      }
    });
*/
    setLoading(false);
  };

  if (loading) {
    return <LoadingContainer>Carregando...</LoadingContainer>;
  }

  return (
    <Container className="mobile:flex-col">
      <Logo
        className="w-2/6 mobile:w-full mobile:mt-40"
        onClick={() => {
          navigate("/home");
        }}
      >
        <img src={capivara} alt="Logo" style={{ cursor: "pointer" }} />
      </Logo>
      <LoginBox className="w-5/6 p-4 laptop:min-w-[600px] desktop:min-w-[800px] mobile:mb-10">
        <FormProvider {...signUpForm}>
          <FormSignUp onSubmit={signUpForm.handleSubmit(handleSubmit)}>
            <PageTitle>Finalizar Cadastro</PageTitle>
            <RadioContainer>
              <span>Eu sou:</span>
              <div
                className="flex items-center justify-around w-full"
                onChange={handleUserType}
              >
                <label>
                  <Radio
                    name="user-type"
                    value="PERSON"
                    checked={userType === "PERSON"}
                  />
                  Pessoa Física
                </label>
                <label>
                  <Radio
                    name="user-type"
                    value="COMPANY"
                    checked={userType === "COMPANY"}
                  />
                  Pessoa Jurídica
                </label>
              </div>
            </RadioContainer>

            <Form.Field height={54}>
              <Form.Label>
                {userType === "COMPANY" ? "Razão social" : "Nome completo"}
              </Form.Label>
              <Form.Input name="name" maskType="text" />
              <Form.ErrorMessage field="name" />
            </Form.Field>

            <Form.Field height={54}>
              <Form.Label>WhatsApp</Form.Label>
              <Form.Input
                name="phone"
                placeholder="DDD 9 0000-0000"
                maskType="tel"
              />
              <Form.ErrorMessage field="phone" />
            </Form.Field>

            <Form.Field height={54}>
              <Form.Label>{userType === "COMPANY" ? "CNPJ" : "CPF"}</Form.Label>
              <Form.Input
                className="text-center"
                placeholder={
                  userType === "COMPANY"
                    ? "00.000.000/0000-00"
                    : "000.000.000-00"
                }
                name="cpfCnpj"
                maskType={userType === "COMPANY" ? "cnpj" : "cpf"}
              />
              <Form.ErrorMessage field="cpfCnpj" />
            </Form.Field>

            <Form.Button type="submit" className="hover:brightness-90 mt-2">
              {loading ? "Carregando..." : "Cadastrar"}
            </Form.Button>
          </FormSignUp>
        </FormProvider>
      </LoginBox>
    </Container>
  );
};
